module.exports = __webpack_public_path__ + "static/livestreaming-4-4e49c97440a5944020308f32371b0fcf.jpg";